import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import EmptyOperationalState from './EmptyOperationalState';

/**
 * 권한 없음 화면 — 사이드바에 없는 메뉴를 URL로 직접 접근했을 때 표시.
 *
 * ⚠️ 이 화면(및 메뉴 숨김)은 UX 안내일 뿐, 보안 경계가 아니다.
 * 실제 데이터 접근 차단은 백엔드 permission 검증이 담당한다 (TODO: 다음 PR).
 */
const AccessDenied = ({ item }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ pt: 5 }}>
      <EmptyOperationalState
        variant="denied"
        title="접근 권한이 없습니다"
        description={`현재 세션에는 이 메뉴를 볼 수 있는 권한이 없어요.${
          item?.label ? ` 요청한 메뉴: ${item.label}.` : ''
        } 권한이 필요하면 매장 관리자에게 문의해 주세요.`}
        actionLabel="홈으로 이동"
        onAction={() => navigate('/owner-v2')}
      />
    </Box>
  );
};

export default AccessDenied;
